export const config = {
  appName: "Maitri",
  address1: "Maitri Trust, 1-B Orchard Court",
  address2: "123/63, Chamiers Road",
  address3: "R.A. Puram, Chennai- 600028",
  phoneNo: "+91 9840028799",
  email: " maitritrust.chennai@gmail.com",
};
export const screens = [
  { pageName: "Home", url: "/" },
  { pageName: "About Us", url: "/about" },
  { pageName: "Programs", url: "/programs" },
  { pageName: "Gallery", url: "/gallery" },
  { pageName: "Contact", url: "/contact" },
];
export const socials = [
  {
    name: "Facebook",
    icon: "fa-facebook-f",
    url: "https://www.facebook.com/maitritrust.org/",
  },
  { name: "Twitter", icon: "fa-twitter", url: "https://www.twitter.com" },
];
export const programs = [
  {
    name: "Pre-primary Support Program (PPSP)",
    description:`<strong>Nurturing Young Minds, Transforming Futures</b>`,
    image: "./../../../img/ppsp.jpg",
  },
  {
    name: "Basic Literacy Program",
    description: `This programme is aimed at students of first to fifth grade studying in Corporation and Govt. aided schools. It is to provide basic knowledge of vernacular language and basic Math skills with the help of volunteers and part-time staff. \n \n \n`,
    image: "./../../../img/blp.jpg",
  },
  {
    name: "Life Skills Programs",
    description: `This programme is aimed at students of sixth to tenth grade studying in corporation and government aided schools. It is a wonderful mixture of basic soft skills and universal values. It also brings awareness on Environment Protection, Personal Hygiene, Community Living etc..through other service providers/NGOs.`,
    image: "./../../../img/lsp.jpg",
  },
  {
    name: "Leadership Through Sports",
    description: `As a pilot project, we worked with one school in R.A. Puram to impart Leadership skills through Sports. Through committed sports resources, we train the children in various sports by providing minimum of two physical training classes per week. We encourage and prepare them to participate in inter school and intra school sports activities.`,
    image: "./../../../img/lts.jpg",
  },
];
export const partners = [
  {
    name: "Full Name",
    title: "Volunteer",
    img: "./../../../img/donate.png",
  },
  {
    name: "Full Name",
    title: "Volunteer",
    img: "./../../../img/donate.png",
  },
  {
    name: "Full Name",
    title: "Volunteer",
    img: "./../../../img/donate.png",
  },
  {
    name: "Full Name",
    title: "Volunteer",
    img: "./../../../img/donate.png",
  },
  {
    name: "Full Name",
    title: "Volunteer",
    img: "./../../../img/donate.png",
  },
  {
    name: "Full Name",
    title: "Volunteer",
    img: "./../../../img/donate.png",
  },
  {
    name: "Full Name",
    title: "Volunteer",
    img: "./../../../img/donate.png",
  },
  {
    name: "Full Name",
    title: "Volunteer",
    img: "./../../../img/donate.png",
  },
  {
    name: "Full Name",
    title: "Volunteer",
    img: "./../../../img/donate.png",
  },
  {
    name: "Full Name",
    title: "Volunteer",
    img: "./../../../img/donate.png",
  },
  {
    name: "Full Name",
    title: "Volunteer",
    img: "./../../../img/donate.png",
  },
  {
    name: "Full Name",
    title: "Volunteer",
    img: "./../../../img/donate.png",
  },
  {
    name: "Full Name",
    title: "Volunteer",
    img: "./../../../img/donate.png",
  },
  {
    name: "Full Name",
    title: "Volunteer",
    img: "./../../../img/donate.png",
  },
  {
    name: "Full Name",
    title: "Volunteer",
    img: "./../../../img/donate.png",
  },
];
export const aboutUs = () => (
  <div className="about-us">
    <p>
      In 2011, a group of visionary individuals in Chennai, India, embarked on a humble journey to transform the lives of underprivileged children. This initiative, Maitri, was born out of a deep passion to provide a nurturing environment where young minds could flourish.
    </p>

    <p>
      We are a registered organization under Section 12AA, with 80G Exemptions and our CSR number is CSR00047960.
    </p>

    <p>
      Maitri is committed to delivering holistic education that goes beyond academics. We believe that every child deserves to be empowered with self-confidence, self-reliance, and good character.
    </p>

    <p>
      At Maitri, we're dedicated to bridging the educational gap for children from economically disadvantaged backgrounds. Our approach is built on three core pillars:
    </p>

    <ul>
      <li><strong>Care:</strong> We provide a safe, supportive, and inclusive environment that fosters emotional growth and well-being.</li>
      <li><strong>Concern:</strong> We're committed to addressing the unique needs of each child, ensuring they receive the attention and resources they deserve.</li>
      <li><strong>Commitment:</strong> We're dedicated to helping our children become capable, compassionate, and responsible individuals who can make a positive impact in their communities.</li>
    </ul>

    <p>
      By joining hands with us, you can be part of a transformative journey that changes lives. Together, let's empower the next generation of leaders, thinkers, and change-makers.
    </p>
  </div>
);
export default aboutUs;


const gimages = [];
const galleryImages = 36;
for (let i = 1; i <= galleryImages; i++) {
  gimages.push({
    name: "Gallery",
    img: `./../../../img/gallery/g${i}.jpg`,
  });
}
export const gallery = gimages;
export const donateData = [
  "Contributing a one time amount of RS. 2,00,000/ per Montessori class room.",
  "Sponsoring an amount of Rs.10,000/ per month per Montessori classroom.",
  "Sponsoring Montessori training costs of women from socio-economic background Rs. 60,000/- per woman",
  "Sponsoring an amount of Rs 30,000/ per year, per school, towards life skills program.",
  "Sponsoring an amount of Rs 15,000/ per month per basic literacy class room.",
];
export const vision = [
  "To nurture cognitive and social development in children of pre primary age group from lower socio-economic backgrounds",
  "To nurture an interest for positive engagements across children of all age groups",
  "To empower women from lower socio-economic backgrounds to become Montessori teachers",
  "To nurture an interest for volunteering and positive engagement across women of all age groups irrespective of where they are in the socio-economic ladder",
];
export const mission = [
  "Identify Anganwadis and Kinder Garten classes of Govt. schools and partner with them to provide Montessori education",
  "Identify and partner with Govt. schools and Aided schools to provide Basic Literacy and Life Skills",
  "Encourage participation of women volunteers in delivering Basic Literacy and Life Skills",
  "Provide Montessori training and employ them in Anganwadis and Kinder Garten classes of Govt. schools",
];
